'use client'

import { cn } from '@/lib/utils'
import { useCallback } from 'react'

interface ProductInfoSuggestSizesProps {
  sizes: Array<{
    title: string
    id: string
    isDisabled?: boolean
  }>
  selectedSizeId?: string
  onSizeChange?: (sizeId: string) => void
}

export const ProductInfoSuggestSizes: React.FC<
  ProductInfoSuggestSizesProps
> = ({ sizes, selectedSizeId, onSizeChange }) => {
  // Sử dụng selectedSizeId từ props hoặc mặc định là item đầu tiên
  const selectedId = selectedSizeId || (sizes.length > 0 ? sizes[0].id : '')

  const handleSizeChange = useCallback(
    (sizeId: string) => {
      if (onSizeChange) {
        onSizeChange(sizeId)
      }
    },
    [onSizeChange]
  )

  return (
    <div>
      <div className='mb-2 flex items-baseline justify-between lg:py-0'>
        <span className='font-sans text-base leading-5 text-neutral-900 max-lg:hidden'>
          Kích thước:{' '}
          <p className='inline text-neutral-600'>
            {sizes.find((s) => s.id === selectedId)?.title || ''}
          </p>
        </span>
      </div>

      <ul className='flex flex-wrap gap-3 lg:gap-4 lg:gap-y-3'>
        {sizes.map((size) => (
          <ProductInfoSuggestSizeItem
            key={size.id}
            isActive={selectedId === size.id}
            onClick={() => handleSizeChange(size.id)}
            title={size.title}
            isDisabled={size.isDisabled}
          />
        ))}
      </ul>
    </div>
  )
}

interface ProductInfoSuggestSizeItemProps {
  isActive?: boolean
  onClick?: () => void
  isDisabled?: boolean
  title: string
}

const ProductInfoSuggestSizeItem = ({
  isActive,
  onClick,
  isDisabled,
  title,
}: ProductInfoSuggestSizeItemProps) => {
  return (
    <li>
      <button
        onClick={isDisabled ? undefined : onClick}
        className={cn(
          'relative h-9 w-13 rounded-xl bg-neutral-100 p-2 font-sans text-base leading-5 text-neutral-600 hover:bg-neutral-900 hover:text-light lg:h-11 lg:w-17.5 lg:bg-neutral-300',
          isDisabled &&
            'pointer-events-none cursor-not-allowed !bg-neutral-100/50 !text-neutral-300 before:absolute before:left-0 before:top-1/2 before:w-full before:rotate-[30deg] before:border-t before:border-dashed before:border-neutral-300 after:absolute after:left-0 after:top-1/2 after:w-full after:rotate-[145deg] after:border-t after:border-dashed after:border-neutral-300 lg:bg-neutral-100/50',
          isActive && 'bg-neutral-900 text-light lg:bg-neutral-900'
        )}
      >
        {title}
      </button>
    </li>
  )
}
